module.exports = {
    runtime: require("./api.chrome.runtime"),
};


// WEBPACK FOOTER //
// src/utils/api/chrome/index.js